"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const DDPProvider_1 = require("./DDPProvider");
const add = (x) => (y) => x + y;
const useDDPCall = ({ onFailure, onSuccess } = {}) => {
    const ddpConnector = (0, react_1.useContext)(DDPProvider_1.DDPContext);
    const [totalPending, setTotalPending] = (0, react_1.useState)(0);
    const ddpCall = (0, react_1.useCallback)((request, options) => {
        if (!request) {
            return Promise.resolve();
        }
        const { name, params } = request;
        setTotalPending(add(1));
        return ddpConnector
            .apply(name, params, options)
            .then((result) => {
            setTotalPending(add(-1));
            if (onSuccess) {
                return onSuccess(result);
            }
            return result;
        })
            .catch((err) => {
            setTotalPending(add(-1));
            if (onFailure) {
                return onFailure(err);
            }
            throw err;
        });
    }, [ddpConnector, setTotalPending, onFailure, onSuccess]);
    return {
        ddpCall,
        ddpIsPending: totalPending > 0,
    };
};
exports.default = useDDPCall;
//# sourceMappingURL=useDDPCall.js.map